import React, { PureComponent } from 'react';
import injectSheet, {withTheme} from 'react-jss'
import { compose } from 'redux'
import CardGrid from '../Card/CardGrid'
import Section from '../Widgets/Section'
import BackgroundContrastContainer from './BackgroundContrastContainer'

class ArticleListing extends PureComponent {
  render() {
    const {
      classes, theme, page, articles, variation, columns = 3,
      background_contrast, show_article_summaries, carousel_on_mobile
    } = this.props;
    if(!articles) return null;
    return (
      <BackgroundContrastContainer applyContrast={background_contrast === 'Yes'}>
        <Section className={classes.flushLastSection}>
          <CardGrid
            columns={columns}
            items={articles}
            singleLine={false}
            carousel={carousel_on_mobile === 'Yes'}
            variation={variation}
            showSummary={show_article_summaries === 'Yes'}
            color={page ? theme.getLandingPageColor(page.landing_page_uid) : undefined}
          />
        </Section>
      </BackgroundContrastContainer>
    );
  }
}

export default compose(
  injectSheet((theme) => ({
    flushLastSection: {
      '&:last-child': {
        marginBottom: 0
      }
    }
  })),
  withTheme
)(ArticleListing)



// WEBPACK FOOTER //
// ./src/components/LandingPage/ArticleListing.js